import { lock } from 'tua-body-scroll-lock';

const selectors = {
  OPEN_ZOOM_SELECTOR: '[data-action="open-zoom"]',
  PRODUCT_MEDIA_SELECTOR: '[data-selector="product-media"]',
  IMAGE_MAIN_SELECTOR: '[data-selector="image-main"]',
  IMAGE_THUMB_SELECTOR: '[data-selector="image-thumb"]',
  MODAL_ZOOM_SELECTOR: 'modal-zoom-gallery',
  SHOW_MORE_IMAGE_SELECTOR: '[data-selector="show-more"]',
};

const classes = {
  ACTIVE: 'is-active',
  HIDDEN: 'hidden',
  HIDDEN_MODAL: 'modal-zoom-gallery--hidden',
};

class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.productMediaEls = this.querySelectorAll(selectors.PRODUCT_MEDIA_SELECTOR);
    this.openZoomEls = this.querySelectorAll(selectors.OPEN_ZOOM_SELECTOR);
    this.imageMainEls = document.querySelectorAll(selectors.IMAGE_MAIN_SELECTOR);
    this.imageThumbEls = document.querySelectorAll(selectors.IMAGE_THUMB_SELECTOR);
    this.modalZoomEl = document.querySelector(selectors.MODAL_ZOOM_SELECTOR);
    this.showMoreImageEl = this.querySelector(selectors.SHOW_MORE_IMAGE_SELECTOR);
    this.abort = new AbortController();

    this.openZoomEls?.forEach((media) => {
      media.addEventListener(
        'click',
        (/** @type {Event} */ event) => this.handlOpenModalZoom(event),
        { signal: this.abort?.signal },
      );
    });

    this.showMoreImageEl?.addEventListener('click', this.toggleImageExpand, {
      signal: this.abort?.signal,
    });
  }

  /**
   * @param {Event} event
   */
  handlOpenModalZoom = (event) => {
    if (!this.modalZoomEl) return;

    const currentTarget = /** @type {HTMLElement} */ (event.currentTarget);
    const targetIndex = currentTarget.dataset?.index;
    const imageMainEl = this.imageMainEls
      ? Array.from(this.imageMainEls).find(
          (item) => /** @type {HTMLElement} */ (item).dataset.target === `img-zoom-${targetIndex}`,
        )
      : null;
    const imageThumbEl = this.imageThumbEls
      ? Array.from(this.imageThumbEls).find(
          (item) => /** @type {HTMLElement} */ (item).dataset.target === `img-zoom-${targetIndex}`,
        )
      : null;

    if (!imageMainEl || !imageThumbEl || !this.modalZoomEl) return;

    lock(/** @type {HTMLElement} */ (this.modalZoomEl));
    this.modalZoomEl.classList.remove(classes.HIDDEN_MODAL);
    this.removeActiveImages(this.imageMainEls);
    this.removeActiveImages(this.imageThumbEls);
    imageMainEl.classList.add(classes.ACTIVE);
    imageThumbEl.classList.add(classes.ACTIVE);
    imageMainEl.scrollIntoView();
    imageThumbEl.scrollIntoView();
  };

  toggleImageExpand = () => {
    if (!this.showMoreImageEl || !this.productMediaEls?.length) return;

    const isExpanded = this.showMoreImageEl.getAttribute('aria-expanded') === 'true';

    this.showMoreImageEl.setAttribute('aria-expanded', String(!isExpanded));

    if (isExpanded) {
      this.productMediaEls.forEach((media, index) => {
        if (index > 4) media.classList.add(classes.HIDDEN);
      });
    } else {
      this.productMediaEls.forEach((media) => {
        media.classList.remove(classes.HIDDEN);
      });
    }
  };

  removeActiveImages = (items) => {
    items.forEach((/** @type {HTMLElement} */ item) => {
      item.classList.remove(classes.ACTIVE);
    });
  };

  disconnectedCallback() {
    this.abort?.abort();
  }
}

if (!customElements.get('product-gallery')) {
  customElements.define('product-gallery', ProductGallery);
}
